/**
 * Display labels, routes, and CTA type for each BK-blocking onboarding item
 * that can appear in the CUBK blocking-items warning banner.
 *
 * These are the 4 EXPEDITE items from EXPEDITE_CARD_IDS in cubk-deadline.
 * IDs match GettingStartedOnboardingStepId enum values (backend step identifiers).
 */
import { GettingStartedOnboardingStep } from '@/features/onboarding/user-onboarding-steps/onboarding.reducer'

export interface BlockingItemRoute {
  id: string
  /** Short name used in the banner title: "Action required: <alertTitle>" */
  alertTitle: string
  /** Body copy rendered beneath the banner title */
  description: string
  route: string | null // null for Plaid modal CTAs
  isPlaidModal: boolean
}

type BlockingItemRouteConfig = Omit<BlockingItemRoute, 'id'>

export const BLOCKING_ITEM_ROUTES: Record<string, BlockingItemRouteConfig> = {
  [GettingStartedOnboardingStep.connectBusinessBankAccount]: {
    alertTitle: 'Connect bank accounts',
    description:
      'Link your business bank account so we can pull in your transactions and get your books started.',
    route: null,
    isPlaidModal: true,
  },
  [GettingStartedOnboardingStep.uploadBankStatements]: {
    alertTitle: 'Fill in transaction gaps',
    description:
      'Some transactions may be missing. Upload bank statements so your bookkeeper has a complete picture.',
    route: '/practice/statements',
    isPlaidModal: false,
  },
  [GettingStartedOnboardingStep.markPersonalTransactions]: {
    alertTitle: 'Mark personal transactions',
    description:
      'Since you flagged some accounts as containing personal transactions, we need your help sorting those out to keep your business finances clean.',
    route: '/transactions',
    isPlaidModal: false,
  },
  [GettingStartedOnboardingStep.clarifyUncategorizedTransactions]: {
    alertTitle: 'Review unclear transactions',
    description:
      'Some transactions need a little more context. Review and categorize them so your bookkeeper can proceed.',
    route: '/transactions/review',
    isPlaidModal: false,
  },
}
